export var ActionApprovalOperationType;
(function (ActionApprovalOperationType) {
    ActionApprovalOperationType["ACTION_APPROVAL_OPERATION_ADD_RESTORE_ACCOUNT"] = "ADD_RESTORE_ACCOUNT";
    ActionApprovalOperationType["ACTION_APPROVAL_OPERATION_CREATE_BACKUP_POLICY"] = "CREATE_BACKUP_POLICY";
    ActionApprovalOperationType["ACTION_APPROVAL_OPERATION_RESTORE_RESOURCE"] = "RESTORE_RESOURCE";
    ActionApprovalOperationType["ACTION_APPROVAL_OPERATION_UPDATE_BACKUP_POLICY"] = "UPDATE_BACKUP_POLICY";
    ActionApprovalOperationType["ACTION_APPROVAL_OPERATION_DELETE_BACKUP_POLICY"] = "DELETE_BACKUP_POLICY";
    ActionApprovalOperationType["ACTION_APPROVAL_OPERATION_REMOVE_SNAPSHOT_HOLD"] = "REMOVE_SNAPSHOT_HOLD";
})(ActionApprovalOperationType || (ActionApprovalOperationType = {}));
